import React, { useEffect, useState } from 'react';
import './datepicker.less';
import { DatePicker, Space, Form } from 'antd';
import MaskedInput from 'antd-mask-input';

import classNames from 'classnames';
import CalendarIcon from '../../assests/icons/calendar.icon';
import { Input } from '../index';
import moment from 'moment';

import momentTr from 'moment/locale/tr';
import { fillZero } from 'utils/utility-functions';

const SelectDatePicker = (props) => {
  
const dateFormat = 'YYYY-MM-DD';

var defaultDate=new Date(props.defaultValue ? props.defaultValue : new Date().getTime() + (2 * 60000));
  const [selectFocused, setSelectFocused] = useState(false);
  const [selectDate, setSelectDate] = useState(props.defaultValue? moment(props.defaultValue, dateFormat)  : "");
  const [inputClock, setInputClock] = useState('');
  const [clockErrorMessg, setClockErrorMessg] = useState(false);
  
  const [selectClock, setSelectClock] = useState(fillZero(defaultDate.getHours())+ ":" + fillZero(defaultDate.getMinutes()));
  useEffect(() => {
    if (props.value || props.defaultValue) {
      setSelectFocused(true);
    } else {
      setSelectFocused(false);
    }
  }, [props.value]);



  function onChangeDate(e) {
    setSelectDate(e);
    props.onChange(e);
  }

  function focusInputDate() {
    setSelectFocused(true);
  }

  function blurInputDate(e) {
    if (selectDate === '') {
      setSelectFocused(false);
    }
  }

  function onChangeClock(e) {
    if (e.indexOf("_") == -1) {
      
      // setInputClock(e.substr(0, 2));
      // const startHour= props.hourStart?props.hourStart:9;
      // const endHour= props.hourEnd?props.hourEnd:21;
      // if (e.substr(0, 2) >= startHour && e.substr(0, 2) <endHour) {
      //   setClockErrorMessg(false);
      // } else {
      //   setClockErrorMessg(true);
      //   return;
      // }
      // if (e.length==7)
      // {
        const  hour= e.split(":")[0].trim();
        const  min= e.split(":")[1].trim();
        if (hour>24 ||  min>60) {
          
          setClockErrorMessg(true);
          return;
        }
        setSelectClock(e);
       // const newDate=new Date(selectDate.format("YYYY-MM-DD") +'T'+hour+':'+ min +':00');
        props.onChange(moment(new Date(selectDate.format("YYYY-MM-DD") +'T'+hour+':'+ min +':00'),"YYYY-MM-DDT:hh:mm:ss" ));
      
      // }
      
    }
    else
    {
      setClockErrorMessg(true);
    }
  }

  const validateClock = (rule, value, callback)  => {
    setClockErrorMessg(false);
    if (value && value.indexOf("_") == -1)
    { 

      const startHour= props.hourStart==0 || props.hourStart?props.hourStart:9;
      const endHour= props.hourEnd?props.hourEnd:21;
      const  hour=value.split(":")[0].trim();
      const  min= value.split(":")[1].trim();

      if (hour>24 ||  min>60) {
        setClockErrorMessg(true);
        callback("Saat hatalı!");
        return;
      }
      if (hour < startHour ||  hour>endHour) {
        setClockErrorMessg(true);
        callback("Saat hatalı!");
        
      }
      else
      {
        callback();
      }
    
  }
  else{
    setClockErrorMessg(true);
    callback("Saat hatalı!");
  }
};

  return (
    <div
      className={classNames(
        'datepicker',
        props.compClass,
        { focus: selectFocused },
        { 'datepicker--small': props.small }
      )}
    >
      <div>
        <div className={classNames('datepicker__date', { full: !props.hours })}>
          {props.label ? <label>{props.label}</label> : false}
          <Space direction="vertical">
            <DatePicker 
              {...props}
              suffixIcon={<CalendarIcon />}
              placeholder={false}
              onChange={(e) => {
                onChangeDate(e);
              }}
              onBlur={blurInputDate}
              onFocus={focusInputDate}
            />
          </Space>
        </div>
        {props.hours ? (
        <Form.Item name={props.formName}  rules={[{validator:validateClock }]} initialValue={selectClock} >
        
            <Input.MaskInput
              compClass="input--big"
              type="text"
              label="Saat"
              name="clock"
              bordered={false}
              onChange={(e) => {
                onChangeClock(e.target.value);
              }}
            />
        </Form.Item>) : (
            false   )}
      </div>
      {clockErrorMessg ? (
        <span className="datepicker__error">
          Yalnızca <span>{props.hourStart==0 || props.hourStart ? props.hourStart:9}:00 - {props.hourEnd? props.hourEnd:12}:00</span> saatleri arasında gönderim
          yapabilirsiniz.
        </span>
      ) : null}
    </div>
  );
};

export default SelectDatePicker;
